import { FlexV } from "../ui/ui"

export const AboutEl = () => {
  return (
    <FlexV
      style={{
        height: "100%",
      }}
    >
      <div
        style={{
          flex: 1,
        }}
      >
        不知不觉积累了一些照片, 展示出来满足一下分享欲, 哈哈
      </div>
      <div>
        <div>个人链接</div>
        <div>
          Github:{" "}
          <a href="https://github.com/MXXXXXS" target="_blank" rel="noreferrer">
            https://github.com/MXXXXXS
          </a>
        </div>
      </div>
    </FlexV>
  )
}
